import { Session } from "../helpers/Models";
import { environment, extension_endpoint, nextJsEndpoint } from "../utils/constants";

export const url_get_session_id = extension_endpoint + "/get_portals_session_id";

export const sessionUrl = nextJsEndpoint[environment] + "/api/sessions/{{session_id}}";

export const getSessionId = async ({ getToken }: { getToken: () => Promise<string | null> }) => {
  const token = await getToken();
  if (!token) {
    console.debug("useSessionId getSessionId no token");
    return undefined;
  }
  const headers: Record<string, string> = {};
  headers["Content-Type"] = "application/json";
  headers["Authorization"] = `Bearer ${token}`;

  try {
    const res = await fetch(url_get_session_id, {
      method: "GET",
      headers: headers,
    });
    const json = await res?.json();
    const sessionId = json?.session_id;
    if (sessionId) {
      return sessionId as string;
    } else {
      console.error("getSessionId -- no session id found");
    }
  } catch (error) {
    console.log("getSessionId error", error);
  }
  return undefined;
};

export const getSession = async ({
  sessionId,
  getToken,
}: {
  sessionId?: string;
  getToken: () => Promise<string | null>;
}) => {
  const token = await getToken();
  if (!token || !sessionId) {
    console.debug("getSession no token or no sessionId");
    return null;
  }
  const headers: Record<string, string> = {};
  headers["Content-Type"] = "application/json";
  headers["Authorization"] = `Bearer ${token}`;

  try {
    const url = sessionUrl.replace("{{session_id}}", sessionId);
    const res = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const json = await res?.json();
    return json as Session;
  } catch (error) {
    console.log("getSession error", error);
  }
  return null;
};

export const updateSession = async ({
  sessionId,
  body,
  getToken,
}: {
  sessionId: string;
  body: any;
  getToken: () => Promise<string | null>;
}) => {
  const token = await getToken();
  if (!token) {
    console.debug("updateSession no token");
    return;
  }
  const headers: Record<string, string> = {};
  headers["Content-Type"] = "application/json";
  headers["Authorization"] = `Bearer ${token}`;

  try {
    const url = sessionUrl.replace("{{session_id}}", sessionId);
    const res = await fetch(url, {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: headers,
    });
    const json = await res?.json();
    return json;
  } catch (error) {
    console.log("updateSession error", error);
    return null;
  }
};
